exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-2eaa378a] {\n  position: fixed;\n  bottom: 0;\n  padding-right: 50px;\n  z-index: 1000;\n  margin-bottom: 0;\n}\n.dismissBtn[data-v-2eaa378a] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: 0;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eaa378a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GlobalMessage.vue
// module id = 636
// module chunks = 3